import { useContext, useState, useEffect, Fragment } from 'react';
import clienteAxios from '../config/axios';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

import Mensaje from '../components/Alertas/Mensaje';
import ModalRetiroUSDT from '../components/Modales/ModalRetiroUSDT';

import Spinner from '../components/spinners/Spinner';
import AuthContext from '../context/autenticacion/authContext';
import ModalNuevaWallet from '../components/Modales/ModalNuevaWallet';
import ModalNuevaCuenta from '../components/Modales/ModalNuevaCuenta';
import ModalDireccionesMaster from '../components/Modales/ModalDireccionesMaster';
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";

import styled, { keyframes } from 'styled-components';
import { useT } from 'i18n';

// Animaciones
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

// Styled Components
const SelectionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
  margin: 1rem 0;
`;

const SelectionCard = styled.div`
  background: ${props => props.active 
    ? 'linear-gradient(135deg, rgba(227,168,43, 0.2), rgba(12,14,19, 0.3))'
    : 'rgba(12,14,19, 0.4)'};
  border: 1px solid ${props => props.active 
    ? '#e3a82b' 
    : 'rgba(227,168,43, 0.2)'};
  border-radius: 16px;
  padding: 1rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-3px);
    border-color: #e3a82b;
    box-shadow: 0 5px 20px rgba(227,168,43, 0.2);
  }
  
  i {
    font-size: 2rem;
    color: #e3a82b;
    margin-bottom: 0.5rem;
  }
  
  p {
    margin: 0;
    font-weight: 600;
  }
  
  span {
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.6);
  }
`;

const InfoText = styled.p`
  text-align: center;
  padding: 1rem;
  background: rgba(227,168,43, 0.1);
  border-radius: 12px;
  color: #e3a82b;
  animation: ${fadeIn} 0.3s ease;
`;

const TableContainer = styled.div`
  overflow-x: auto;
  margin-top: 1rem;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  
  th, td {
    padding: 0.75rem;
    text-align: left;
    border-bottom: 1px solid rgba(227,168,43, 0.1);
    vertical-align: middle;
  }

  td .btn { margin: 0 !important; }
  
  th {
    color: #e3a82b;
    font-weight: 600;
  }
  
  tr:hover {
    background: rgba(227,168,43, 0.05);
  }
`;

const AddBeneficiaryBtn = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  color: #e3a82b;
  transition: all 0.3s ease;
  
  &:hover {
    color: #e3a82b;
    transform: translateX(3px);
  }
  
  i {
    font-size: 1rem;
  }
`;

const ModalCard = styled.div`
  background: linear-gradient(135deg, #0c0e13, #0c0e13);
  border-radius: 24px;
  border: 1px solid rgba(227,168,43, 0.3);
  max-width: 600px;
  width: 90%;
  margin: auto;
  animation: ${fadeIn} 0.3s ease;
`;

const ModalHeader = styled.div`
  background: linear-gradient(135deg, rgba(18,21,28, 0.9), rgba(12,14,19, 0.95));
  padding: 1rem 1.5rem;
  border-bottom: 1px solid rgba(227,168,43, 0.3);
  border-radius: 24px 24px 0 0;
`;

const ModalBody = styled.div`
  padding: 1.5rem;
  max-height: 70vh;
  overflow-y: auto;
`;

const ModalFooter = styled.div`
  padding: 1rem 1.5rem;
  border-top: 1px solid rgba(227,168,43, 0.2);
  display: flex;
  justify-content: center;
`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 0.875rem;
  border-radius: 50px;
  border: none;
  background: #e3a82b;
  color: #14100a;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(227,168,43, 0.4);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#12151cb7',
  },
  paper: {
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
  },
}));

function getModalStyle() {
  const top = 50;
  const left = 50;
  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const Retiro = () => {
  const { t, ts } = useT();
  const [opendireccion, setOpenDireccion] = useState(false);
  const [modalmensaje, setModalMensaje] = useState(false);
  const [modalremesadora, setModalRemesadora] = useState(false);
  const [modalterceros, setModalTerceros] = useState(false);
  const [modalnacional, setModalNacional] = useState(false);
  const [modalinternacional, setModalInternacional] = useState(false);
  const [elcargando, elGuardarCargando] = useState(false);
  const [apiload, guardarApiLoad] = useState(true);
  const [pin, guardarPin] = useState("");
  const [mensaje, guardarMensaje] = useState({ message: "" });

  const [state, setState] = useState({ check: false });
  const { check } = state;

  const [listaretiros, guardarListaRetiros] = useState([]);
  const [cuentaspropias, setCuentasPropias] = useState([]);
  const [cuentasterceros, setCuentasTerceros] = useState([]);
  const [cuentasremesas, setCuentasRemesas] = useState([]);
  const [cantidad, guardarCantidades] = useState({});

  const [retiro, guardarRetiro] = useState({
    beneficiario_id: '',
    monto: '',
    amount: '',
    type: '',
    ventanilla: '',
  });

  const [addben, guardarAddBen] = useState({
    country_id: '',
    bank_client: '',
    bank_swift: '',
    bank_name: '',
    bank_account: '',
    bank_personal: '',
    bank_type: '',
    bank_aba: '',
    bank_apellidos: '',
    provincia: '',
    ciudad: '',
    direccion_cliente: '',
    tipo_identificacion: '',
    identificacion: '',
    telefono: '',
    address_cripto: '',
    network: '',
  });

  const [modalInfo, setModalInfo] = useState([]);

  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpenDireccion = () => setOpenDireccion(true);
  const handleCloseDireccion = () => setOpenDireccion(false);
  const abrirMensaje = () => setModalMensaje(true);
  const cerrarMensaje = () => { setModalMensaje(false); guardarMensaje({ message: "" }); };
  const abrirRemesadora = () => setModalRemesadora(true);
  const cerrarRemesadora = () => { setModalRemesadora(false); guardarMensaje({ message: "" }); };
  const cerrarTerceros = () => { setModalTerceros(false); guardarMensaje({ message: "" }); };
  const abrirNacional = () => setModalNacional(true);
  const cerrarNacional = () => { setModalNacional(false); guardarMensaje({ message: "" }); };
  const abrirInternacional = () => setModalInternacional(true);
  const cerrarInternacional = () => { setModalInternacional(false); guardarMensaje({ message: "" }); };

  const ApiLoad = () => {
    guardarApiLoad(false);
    setTimeout(() => guardarApiLoad(true), 3);
  };

  const authContext = useContext(AuthContext);
  const {
    cuentas_internacionales,
    cuentas_nacionales,
    cuentas_remesas,
    retiros_cantidad,
    retiros,
    ListaNacionales,
    ListaInternacionales,
    ListaRemesas,
    TodosRetiros,
    demo_status,
    usuario
  } = authContext;

  useEffect(() => {
    ListaNacionales();
    ListaInternacionales();
    ListaRemesas();
    TodosRetiros();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setCuentasTerceros(cuentas_internacionales || []);
    setCuentasPropias(cuentas_nacionales || []);
    setCuentasRemesas(cuentas_remesas || []);
    guardarListaRetiros(retiros);
    guardarCantidades(retiros_cantidad);
  }, [apiload, cuentas_internacionales, cuentas_nacionales, cuentas_remesas, retiros_cantidad, retiros]);

  const consultarApiRetiroTransferencia = async () => {
    try {
      const respuesta = await clienteAxios.post('/api/client/withdrawall/create', retiro);
      guardarMensaje({ message: ts(respuesta.data.message) });
      guardarPin(respuesta.data.data?.pin || '');
      elGuardarCargando(false);
      handleClose();
      abrirMensaje();
    } catch (error) {
      elGuardarCargando(false);
      handleClose();
      guardarMensaje({ message: ts(error.response?.data?.message) || t('retiro.error') });
      abrirMensaje();
    }
  };

  const onChange = (e) => {
    const x_total = parseFloat(document.getElementById("amount")?.value || 0);
    const x_flat = parseFloat(usuario?.tasas?.monto_flat || 0);
    const x_porcentual = parseFloat(usuario?.tasas?.monto_porcentual || 0);

    const xFinalElement = document.getElementById("x_final");
    const xRestaElement = document.getElementById("x_resta");

    if (x_total > 0) {
      const x_porcentual_new = (x_porcentual / 100) * x_total;
      const x_final = x_total - x_flat - x_porcentual_new;
      const x_resta = x_total - x_final;

      if (xFinalElement) xFinalElement.innerHTML = `${x_final.toFixed(2)} USDT`;
      if (xRestaElement) xRestaElement.innerHTML = `${x_resta.toFixed(2)} USDT`;
    } else {
      if (xFinalElement) xFinalElement.innerHTML = "0.00 USDT";
      if (xRestaElement) xRestaElement.innerHTML = "0.00 USDT";
    }

    guardarRetiro({ ...retiro, [e.target.name]: e.target.value });
  };

  const onSubmitTransferencia = (e) => {
    elGuardarCargando(true);
    e.preventDefault();
    consultarApiRetiroTransferencia();
  };

  const elguardar = elcargando ? <Spinner /> : <Fragment>{t('retiro.solicitarBtn')}</Fragment>;

  const handleCloseAll = () => {
    cerrarTerceros();
    cerrarMensaje();
    cerrarInternacional();
    cerrarNacional();
    cerrarRemesadora();
    handleClose();
    ApiLoad();
    guardarAddBen({});
    ListaNacionales();
    ListaInternacionales();
    ListaRemesas();
    TodosRetiros();
  };

  return (
    <>
      <div className="content">
        <Row className="d-flex justify-content-center">
          <Col md="12" className="deposito-col-box">
            <Card className="mb-1">
              <CardHeader>
                <h3 className="title display-4 mb-0">{t('retiro.titulo')}</h3>
                <hr className="my-3 border-info" />
                <p className="retiro-type-fix">{t('retiro.subtitulo')}</p>
              </CardHeader>
              <CardBody>
                <SelectionGrid>
                  <SelectionCard active={retiro.type === ""} onClick={() => guardarRetiro({ ...retiro, type: '' })}>
                    <i className="tim-icons icon-chart-pie-36" />
                    <p>{t('retiro.todos')}</p>
                    <span>{t('retiro.listado')}</span>
                  </SelectionCard>
                  <SelectionCard active={retiro.type === "1"} onClick={() => guardarRetiro({ ...retiro, type: '1' })}>
                    <i className="tim-icons icon-bank" />
                    <p>{t('retiro.nacional')}</p>
                    <span>{t('retiro.panama')}</span>
                  </SelectionCard>
                  <SelectionCard active={retiro.type === "2"} onClick={() => guardarRetiro({ ...retiro, type: '2' })}>
                    <i className="tim-icons icon-globe" />
                    <p>{t('retiro.internacional')}</p>
                    <span>{t('retiro.global')}</span>
                  </SelectionCard>
                  <SelectionCard active={retiro.type === "3"} onClick={() => guardarRetiro({ ...retiro, type: '3' })}>
                    <i className="tim-icons icon-wallet-43" />
                    <p>{t('retiro.cripto')}</p>
                    <span>USDT</span>
                  </SelectionCard>
                </SelectionGrid>

                {retiro.type === "" && <InfoText><i className="tim-icons icon-chart-pie-36 mr-2" />{t('retiro.infoTodos')}</InfoText>}
                {retiro.type === "1" && <InfoText><i className="tim-icons icon-bank mr-2" />{t('retiro.infoNacional')}</InfoText>}
                {retiro.type === "2" && <InfoText><i className="tim-icons icon-globe mr-2" />{t('retiro.infoInternacional')}</InfoText>}
                {retiro.type === "3" && <InfoText><i className="tim-icons icon-wallet-43 mr-2" />{t('retiro.infoCripto')}</InfoText>}
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Lista de retiros */}
        {retiro.type === "" && cantidad > 0 && (
          <Col md="12">
            <Card className="deposito-bg mt-3">
              <CardBody>
                <h2 className="mb-3">{t('retiro.listaTitulo')}</h2>
                <TableContainer>
                  <StyledTable>
                    <thead>
                      <tr>
                        <th>{t('retiro.colCodigo')}</th><th>{t('retiro.colFecha')}</th><th>{t('retiro.colBeneficiario')}</th><th>{t('retiro.colInfo')}</th><th>{t('retiro.colMoneda')}</th><th>{t('retiro.colMonto')}</th><th>{t('retiro.colEstado')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listaretiros.map(item => (
                        <tr key={item.id}>
                          <td>{item.id}</td><td>{item.fecha}</td><td>{item.beneficiario}</td><td>{ts(item.tipo)}</td>
                          <td>{item.currency_tag}</td><td className="text-success">${item.monto}</td>
                          <td><span className="badge badge-success">{ts(item.estado)}</span></td>
                        </tr>
                      ))}
                    </tbody>
                  </StyledTable>
                </TableContainer>
              </CardBody>
            </Card>
          </Col>
        )}

        {/* Transferencia Nacional */}
        {retiro.type === "1" && (
          <Row className="justify-content-center mt-3">
            <Col md="12">
              <Card>
                <CardHeader><h3>{t('retiro.nacional')}</h3></CardHeader>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3" onClick={abrirNacional} style={{cursor:"pointer"}}>
                    <h5 className="mb-0">{t('retiro.selBeneficiario')}</h5>
                    <AddBeneficiaryBtn><i className="tim-icons icon-simple-add" /> {t('retiro.addBeneficiario')}</AddBeneficiaryBtn>
                  </div>
                  <TableContainer>
                    <StyledTable>
                      <thead><tr><th>{t('retiro.colBanco')}</th><th>{t('retiro.colTitular')}</th><th>{t('retiro.colCuenta')}</th><th>{t('retiro.colTipo')}</th><th className="text-center">{t('retiro.colSeleccion')}</th></tr></thead>
                      <tbody>
                        {cuentaspropias.map(cuenta => (
                          <tr key={cuenta.id}>
                            <td>{cuenta.bank_name}</td><td>{cuenta.bank_client}</td><td>{cuenta.bank_account}</td><td>{cuenta.bank_type}</td>
                            <td className="text-center">
                              <button className="btn btn-primario btn-sm" onClick={() => { handleOpen(); setModalInfo(cuenta); guardarRetiro({ ...retiro, beneficiario_id: cuenta.id }); }}>
                                {t('retiro.retirar')}
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </StyledTable>
                  </TableContainer>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        {/* Transferencia Internacional */}
        {retiro.type === "2" && (
          <Row className="justify-content-center mt-3">
            <Col md="12">
              <Card>
                <CardHeader><h3>{t('retiro.internacional')}</h3></CardHeader>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3" onClick={abrirInternacional} style={{cursor:"pointer"}}>
                    <h5 className="mb-0">{t('retiro.selBeneficiario')}</h5>
                    <AddBeneficiaryBtn><i className="tim-icons icon-simple-add" /> {t('retiro.addBeneficiario')}</AddBeneficiaryBtn>
                  </div>
                  <TableContainer>
                    <StyledTable>
                      <thead><tr><th>{t('retiro.colBanco')}</th><th>{t('retiro.colTitular')}</th><th>{t('retiro.colCuenta')}</th><th>{t('retiro.colTipo')}</th><th className="text-center">{t('retiro.colSeleccion')}</th></tr></thead>
                      <tbody>
                        {cuentasterceros.map(cuenta => (
                          <tr key={cuenta.id}>
                            <td>{cuenta.bank_name}</td><td>{cuenta.bank_client}</td><td>{cuenta.bank_account}</td><td>{cuenta.bank_type}</td>
                            <td className="text-center">
                              <button className="btn btn-primario btn-sm" onClick={() => { handleOpen(); setModalInfo(cuenta); guardarRetiro({ ...retiro, beneficiario_id: cuenta.id }); }}>
                                {t('retiro.retirar')}
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </StyledTable>
                  </TableContainer>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        {/* Transferencia Cripto */}
        {retiro.type === "3" && (
          <Row className="justify-content-center mt-3">
            <Col md="12">
              <Card>
                <CardHeader className="d-flex justify-content-between align-items-center">
                  <h3 className="mb-0">{t('retiro.retirarUsdt')}</h3>
                  <button type="button" className="p7-btn-gold" onClick={abrirRemesadora}>{t('retiro.nuevaWallet')}</button>
                </CardHeader>
                <CardBody>
                  {cuentasremesas.length === 0 ? (
                    <div className="p7-empty">
                      <p>{t('retiro.sinWallets')}</p>
                      <p className="p7-empty-sub">{t('retiro.sinWalletsAyuda')}</p>
                      <button type="button" className="p7-btn-gold" onClick={abrirRemesadora}>{t('retiro.primeraWallet')}</button>
                    </div>
                  ) : (
                    <TableContainer>
                      <StyledTable>
                        <thead><tr><th>{t('retiro.colNombre')}</th><th>{t('retiro.colRed')}</th><th>{t('retiro.colDireccion')}</th><th></th></tr></thead>
                        <tbody>
                          {cuentasremesas.map(cuenta => (
                            <tr key={cuenta.id}>
                              <td>{cuenta.bank_client}</td>
                              <td>{cuenta.network}</td>
                              <td title={cuenta.address_cripto}>{cuenta.address_cripto ? `${cuenta.address_cripto.slice(0, 8)}…${cuenta.address_cripto.slice(-6)}` : '—'}</td>
                              <td><button className="btn btn-primario btn-sm" onClick={() => { handleOpen(); setModalInfo(cuenta); guardarRetiro({ ...retiro, beneficiario_id: cuenta.id }); }}>{t('retiro.retirar')}</button></td>
                            </tr>
                          ))}
                        </tbody>
                      </StyledTable>
                    </TableContainer>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </div>

      <ModalNuevaCuenta
        abierto={modalnacional || modalinternacional}
        tipo={modalinternacional ? 'internacional' : 'nacional'}
        onCerrar={() => { setModalNacional(false); setModalInternacional(false); }}
        onGuardada={() => { setModalNacional(false); setModalInternacional(false); ListaNacionales(); ListaInternacionales(); }}
      />
      <ModalNuevaWallet
        abierto={modalremesadora}
        onCerrar={cerrarRemesadora}
        onGuardada={() => { cerrarRemesadora(); ListaRemesas(); }}
      />

      {/* Modales y resto del código... */}
      <ModalRetiroUSDT
        open={open}
        wallet={modalInfo}
        tipo={retiro.type}
        monto={retiro.amount || ''}
        setMonto={(v) => guardarRetiro({ ...retiro, amount: v })}
        onSubmit={onSubmitTransferencia}
        cargando={elcargando}
        onClose={handleClose}
      />

      <ModalDireccionesMaster opendireccion={opendireccion} handleCloseDireccion={handleCloseDireccion} handleOpenDireccion={handleOpenDireccion} />

      {mensaje.message && modalmensaje && (
        <Mensaje mensaje={mensaje.message} guardarMensajeOpen={handleCloseAll} guardarMensaje={() => {}} />
      )}
    </>
  );
};

export default Retiro;